<h2 mat-dialog-title>📲 Vista Previa de la Comunicación</h2>

<mat-dialog-content>
    <div class="phone">
        <div class="notification">
            <div class="app">BENEFICIOS</div>
            <div class="title">{{ data.title }}</div>
            <div class="body">{{ data.body }}</div>
        </div>
    </div>

    <p class="info" *ngIf="data.cantidad">
        Esta comunicación se enviará a <b>{{ data.cantidad }}</b> destinatarios (Alerta Push + Mensaje Interno en App).
    </p>
    <p class="info" *ngIf="!data.cantidad">
        Se enviará la alerta Push y se registrará el mensaje interno en la bandeja del usuario.
    </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancelar()">Cancelar</button>
    <button mat-raised-button color="primary" (click)="confirmar()">
        Confirmar y Enviar 🚀
    </button>
</mat-dialog-actions>
